import {createSlice, PayloadAction } from '@reduxjs/toolkit';
import { type RootState } from '../../store';

// Define a type for the slice state
export interface goBackState {
  type: string
}

// Define the initial state using that type
const initialState: goBackState = {
    type: 'None',
}

export const goBackSlice = createSlice({
  name: 'goBack',
  initialState,
  reducers: {
    setGoBack: (state, action: PayloadAction<string>)=>{
        state.type = action.payload;
    }
  },
});
    

export const { setGoBack} = goBackSlice.actions


export default goBackSlice.reducer